/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext, type ReactNode } from 'react';
import { toast } from 'sonner';
import apiClient from '../api/client';
interface AdminContextType {
    getAdminSettings: (setSettings: React.Dispatch<React.SetStateAction<Settings>>)=> void;
}

export interface Settings{
  headerLogo?: File | string | null;
  footerLogo?: File | string | null;

  name?: string;
  email?: string;
  description?: string;
  radioLink?: string;

  socialLinks?: Record<string, string>;
  phones?: string[];       

  address?: string;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export function AdminProvider({ children }: { children: ReactNode }) {

    const getAdminSettings = async(setSettings: React.Dispatch<React.SetStateAction<Settings>>)=>{
        try{
            const {data} = await apiClient.get('/admin/get-settings')

            if(data?.success){
                const settings = data?.settings
                setSettings(settings)
            }

        }
        catch(error: any){
            toast.error(error?.response?.data?.message || error?.message)
        }
    }

    const value = {
        getAdminSettings
    };

    return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};